<!--
  app.component.html
  ------------------
  Root shell. Layout present on every page.

  Stack (top to bottom):
    1. app-header      — always shown (logo + app name + user name)
    2. app-stepper-nav — shown only on assessment flow pages
    3. router-outlet   — page-specific content injected here
    4. msal-redirect   — hidden component that processes Entra ID redirect responses
-->

<!-- 1. Application header — always visible -->
<app-header></app-header>

<!-- 2. Step navigation bar — visible only on assessment flow pages -->
<app-stepper-nav *ngIf="showStepper"></app-stepper-nav>

<!-- 3. Page content -->
<main class="app-content">
  <router-outlet></router-outlet>
</main>

<!-- 6. Sticky General Chatbot Button (bottom-right, hidden on /chat page) -->
<a
  *ngIf="!isChatPage"
  routerLink="/chat"
  target="_blank"
  rel="noopener noreferrer"
  class="chatbot-fab"
  aria-label="Open CDAS General Guardrails Assistant">
  <span class="chatbot-fab__icon">
    <img src="chatbot.png" alt="Guardrails Assistant" width="36" height="36" />
  </span>
  <span class="chatbot-fab__label">General Guardrails Assistant</span>
</a>

<!-- 4. Session timeout warning modal -->
<div class="timeout-overlay" *ngIf="sessionService.showTimeoutWarning()">
  <div class="timeout-modal" role="alertdialog" aria-modal="true" aria-labelledby="timeoutTitle" aria-describedby="timeoutDesc">
    <div class="timeout-modal__icon">⏱️</div>
    <h2 class="timeout-modal__title" id="timeoutTitle">Session Expiring Soon</h2>
    <p class="timeout-modal__body" id="timeoutDesc">
      Your session will expire in <strong>30 seconds</strong> due to inactivity.<br>
      Would you like to extend your session by 30 minutes?
    </p>
    <div class="timeout-modal__actions">
      <button class="timeout-modal__btn timeout-modal__btn--primary" (click)="extendSession()">
        Extend Session
      </button>
      <button class="timeout-modal__btn timeout-modal__btn--secondary" (click)="endSessionNow()">
        End Session
      </button>
    </div>
  </div>
</div>

<!-- 5. Session expired full-page screen -->
<div class="expired-overlay" *ngIf="sessionService.showSessionExpired()">
  <div class="expired-screen" role="alert" aria-live="assertive">
    <div class="expired-screen__icon">🔒</div>
    <h1 class="expired-screen__title">Session Expired</h1>
    <p class="expired-screen__body">
      Your session expired due to inactivity.<br>
      Please start a new session to continue.
    </p>
    <button class="expired-screen__btn" (click)="startNewSession()">
      Start New Session
    </button>
  </div>
</div>
